import { css } from "emotion";

import { colors } from "@cobliteam/base-components/src/styles/colors";

export const cardContainer = css`
  display: flex;
  flex-direction: column;
  padding: 25px 20px 15px;
  border: 1px solid ${colors.gray.light};
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
`;

export const divider = css`
  && {
    margin: 25px 0 15px;
  }
`;

export const footerContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const footerDescription = css`
  max-width: 205px;
`;
